import React, {FC, Fragment} from 'react';
import styled, {css} from 'styled-components';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import {COLORS} from '../../../constants/colors';
import {mediaDesktopAndUp} from '../../../constants/customMedia';

interface TitleStyles {
  boldTitle?: boolean;
  defaultSize: keyof typeof FONT_SIZES;
  mediumSize?: keyof typeof FONT_SIZES;
  titleColor?: string;
}

interface Props extends TitleStyles {
  title: string;
  superText?: string;
  className?: string;
}

type AlignmentInterface = {
  bannerAlignment: 'center' | 'left';
};

const Text = styled.h4<AlignmentInterface & TitleStyles>`
  color: ${({titleColor}) => titleColor || COLORS.White};
  margin: 0;
  text-align: ${({bannerAlignment}) =>
    bannerAlignment === 'left' ? 'left' : 'center'};
`;

const Title = styled(Text)<TitleStyles>`
  font-size: ${({defaultSize}) => FONT_SIZES[defaultSize]};
  font-weight: ${props =>
    props.boldTitle ? FONT_WEIGHTS.bold : FONT_WEIGHTS.mediumBold};

  ${({mediumSize}) =>
    mediumSize &&
    css`
      @media ${mediaDesktopAndUp} {
        font-size: ${FONT_SIZES[mediumSize]};
      }
    `}
`;

const Bold = styled.span`
  font-weight: ${FONT_WEIGHTS.bold};
`;

const BoldText: React.FC<{title: string}> = ({title}) => {
  return (
    <>
      {title.split('**').map((part, i) => {
        if (i % 2 === 0) {
          return <Fragment key={i}>{part}</Fragment>;
        } else {
          return <Bold key={i}>{part}</Bold>;
        }
      })}
    </>
  );
};

export const BannerTitle: FC<Props & AlignmentInterface> = ({
  title,
  superText,
  titleColor,
  boldTitle,
  bannerAlignment,
  defaultSize,
  mediumSize,
  className,
}) => {
  return (
    <Title
      data-testid="bannerTitle"
      bannerAlignment={bannerAlignment}
      boldTitle={boldTitle}
      defaultSize={defaultSize}
      mediumSize={mediumSize}
      titleColor={titleColor}
      className={className}
    >
      <BoldText title={title} />
      {superText && (
        <StyledSuperTag data-testid="bannerTitleSuperTag" as="sup">
          {superText}
        </StyledSuperTag>
      )}
    </Title>
  );
};

const StyledSuperTag = styled(Bold)`
  margin-left: 3px;
`;
